module.exports = __webpack_public_path__ + "img/code.00c754d3.jpg";